// extracted by css-extract-rspack-plugin
export default {"logo":"featuredIn-module__logo"};